// What's new in the Banger app, written for players: no internal names, no build numbers beyond the version people
// see in the app. The Gate's `whats-new` section shows the newest entry and stays hidden while this list is empty.
// Add an entry only once release-ops has published that version (docs/build/release.md).

export interface ReleaseNote {
  /** the version the app shows, e.g. "0.1.1" */
  version: string;
  /** publish day, YYYY-MM-DD */
  date: string;
  /** one line, the headline of the release */
  title: string;
  /** what changed, one plain sentence each */
  items: { title: string; body: string }[];
}

export const RELEASE_NOTES: ReleaseNote[] = [];

/** The newest published note (by date), or null. */
export function latestNote(notes: readonly ReleaseNote[] = RELEASE_NOTES): ReleaseNote | null {
  const ok = notes.filter((n) => /^\d{4}-\d{2}-\d{2}$/.test(n.date) && n.items.length > 0);
  return ok.sort((a, b) => b.date.localeCompare(a.date))[0] ?? null;
}
